/**
 * Цвет линий символа на плане из цвета предмета.
 *
 * Символ рисуется цветом предмета, но белый гарнитур или серебристый холодильник
 * на светлом полу или белой стене развёртки не видны вовсе. Слишком светлый цвет затемняем, сохраняя оттенок, —
 * так символ остаётся «своего» цвета и читается как линия чертежа. В 3D цвет не меняется.
 */

/** Выше этой яркости (0…1) цвет считаем слишком светлым для линий. */
const MAX_LIGHTNESS = 0.62;

export const planInk = (color: string): string => {
	const hex = /^#([0-9a-f]{6})/i.exec(color)?.[1];
	if (!hex) return color;
	const rgb = [0, 2, 4].map((i) => parseInt(hex.slice(i, i + 2), 16));
	const lightness = (0.2126 * rgb[0] + 0.7152 * rgb[1] + 0.0722 * rgb[2]) / 255;
	if (lightness <= MAX_LIGHTNESS) return color;
	const k = (MAX_LIGHTNESS - 0.25) / lightness;
	return `#${rgb
		.map((c) =>
			Math.round(c * k)
				.toString(16)
				.padStart(2, "0"),
		)
		.join("")}`;
};
